'use strict';

const translationsManager = require('services/widget_basic_resources/translations_manager');

const createWidget = require('./create_widget').default;

const parseTemplates = (stringTemplates) => {
    return Odigeo._.reduce(stringTemplates, (templates, stringTemplate, name) => {
        templates[name] = Odigeo._.template(stringTemplate, Odigeo.Utils.getTmplSettings());
        return templates;
    }, {});
};

const getResources = ({name, templates}) => {
    const resources = {
        templates: parseTemplates(templates),
    };
    const translationsPromise = Odigeo._.isString(name) ?
        translationsManager.getWidgetTranslations(name) :
        Promise.resolve({});
    return translationsPromise
        .then((translations) => Odigeo._.extend(translations, resources));
};

module.exports = function(config) {
    return {
        create(options = {}) {
            return createWidget(config, options, getResources);
        },
    };
};
